import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FORMATED_CONTACT_NO } from "../../services/constants";
const styles = theme => ({
  root: {
    backgroundColor: "#EEF4FE",
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: "300px"
  },
  loginRoot: {
    height: "50px"
  },
  rights: { padding: "10px 10px 10px 90px" },
  helpText: { ...theme.typography.tertiaryFont },
  phone: {
    ...theme.typography.defaultFont,
    color: theme.palette.primary.main,
    fontSize: "13px",
    fontWeight: 600
  },
  helpContainer: { textAlign: "center" },
  copyright: { ...theme.typography.tertiaryFont, textAlign: "left" },
  loginContainer: { padding: "15px" },
  isMobile: {
    ["@media (max-width:576px)"]: {
      maxWidth: "100%",
      flexBasis: "unset",
      textAlign: "center",
      margin: "0 auto"
    }
  }
});

class SecondaryFooter extends Component {
  render() {
    const { classes, curYear, isMobile = false } = this.props;
    return (
      <Grid container className={classes.loginContainer}>
        <Grid item xs={4} className={classes.isMobile}>
          <div className={classes.helpContainer}>
            <span className={classes.helpText}>Need help? Reach us at </span>
            {"  "}|{"  "}
            <span className={classes.phone}> {FORMATED_CONTACT_NO}</span>
          </div>
        </Grid>
        <Grid item sm={1} />
        <Grid item xs={8} sm={7}>
          {!isMobile ? (
            <span className={classes.copyright}>
              All rights reserved © {curYear} Info Edge (India) Ltd.
            </span>
          ) : null}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(SecondaryFooter);
